import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  Box,
  Button,
  Container,
  Divider,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  TextField,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import Strength from "../../../Shared-ui/Types/Auth";
import { PasswordStrengthCheck } from "../../../Shared-ui/utils/Auth/AuthHelpers";
import { useDispatch } from "react-redux";
import { ShowError, ShowSuccess } from "../../../Shared-ui/Store/MessageReducer/MsgActions";
import userContext from "../../../Shared-ui/Context/UserContext";
import { User } from "../../../Shared-ui/Types/User";
import { userInitial } from "../../../Shared-ui/Store/UserReducer/UserReducer";
import { StartLoading, StopLoading } from "../../../Shared-ui/Store/LoadingReducer/LoaderActions";
import BaseInstance from "../../../Services/AxiosInstance/BaseInstance";
import { ME } from "../../../Services/Endpoint";

interface MyComponentProps { }

const PassResetForm: React.FC<MyComponentProps> = () => {
  const { user, updateUserContext } = useContext(userContext);
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState<{ [key: string]: boolean }>({
    newPassword: false,
    currentPassword: false,
  }); // New state for toggle
  const [strengthNew, setStrengthNew] = useState<Strength>({
    label: "Password strength ",
    color: "",
    strength: "",
  });
  const [strengthConf, setStrengthConf] = useState<Strength>({
    label: "Password strength ",
    color: "",
    strength: "",
  });
  const [resetForm, setResetForm] = useState({
    newPassword: "",
    confirmPassword: "",
  });

  const [userForm, setUserForm] = useState<User>(userInitial)


  useEffect(() => {
    setUserForm(user);
  }, [user]);


  const handleTogglePassword = (fieldName: string) => {
    // setShowPassword((prev) => !prev); // Toggle show/hide
    let value = showPassword[fieldName];
    setShowPassword((prev) => ({ ...prev, [fieldName]: !value })); // Toggle show/hide
  };
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setResetForm((preVal) => ({ ...preVal, [name]: value }));
    setUserForm(preVal => ({ ...preVal, password: value }))
    if (name === "newPassword") {
      setStrengthNew(PasswordStrengthCheck(value));
    }
    if (name === "confirmPassword") {
      setStrengthConf(PasswordStrengthCheck(value));
    }
  };
  const validateForm = () => {
    if (
      Number(strengthNew.strength) != 80 &&
      Number(strengthNew.strength) != 100
    ) {
      return false;
    }
    if (
      Number(strengthConf.strength) != 80 &&
      Number(strengthConf.strength) != 100
    ) {
      return false;
    }
    if (resetForm.newPassword != resetForm.confirmPassword) {
      dispatch(ShowError("Password not match"));
      return false;
    }
    return true;
  };
  const handleSubmit = async () => {
    if (!validateForm()) return
    try {
      dispatch(StartLoading());
      const data = await BaseInstance.put(ME, userForm).then(
        (res) => res?.data
      );
      dispatch(ShowSuccess("password updated"));
      //  TO update user context after userform update
      updateUserContext();
    } catch (err) {
      console.log(err);
    } finally {
      dispatch(StopLoading());
    }
  }

  return (
    <>
      <Typography variant="h6">Password</Typography>
      <Typography variant="body2">Change your Password here.</Typography>
      <Divider sx={{ my: 2 }} />
      <Box maxWidth="sm">

        <Box
          sx={{
            display: "flex",
            flexDirection: { md: "row", sm: "column", xs: "column" },
            width: "100%",
            gap: { md: "30px", sm: "10px" },
            mb: "30px",
          }}
        >
          <Box
            sx={{
              width: "100%",
            }}
          >
            <FormControl fullWidth variant="outlined">
              <InputLabel
                htmlFor="newPassword"
                shrink
                sx={{ background: "#fff", px: 0.5 }}
              >
                New password
              </InputLabel>
              <OutlinedInput
                id="newPassword"
                name="newPassword"
                type={showPassword.newPassword ? "text" : "password"}
                onChange={handleChange}
                placeholder="New Password"
                sx={{ background: "white" }}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => handleTogglePassword("newPassword")}
                      edge="end"
                      aria-label="toggle password visibility"
                    >
                      {showPassword.newPassword ? (
                        <VisibilityOff />
                      ) : (
                        <Visibility />
                      )}
                    </IconButton>
                  </InputAdornment>
                }
                label="New Password"
              />
            </FormControl>
            <Box sx={{ mt: 1 }}>
              <Box
                sx={{
                  height: "4px",
                  width: "100%",
                  backgroundColor: "lightgray",
                  borderRadius: "2px",
                  overflow: "hidden",
                }}
              >
                <Box
                  sx={{
                    height: "100%",
                    width: `${strengthNew.strength}%`,
                    backgroundColor: strengthNew.color,
                  }}
                />
              </Box>
              <Typography
                variant="caption"
                color={strengthNew.color}
                sx={{ mt: 1, textAlign: "right", display: "block" }}
              >
                {strengthNew.label}
              </Typography>
            </Box>
          </Box>

          <Box
            sx={{
              width: "100%",
            }}
          >
            <FormControl fullWidth variant="outlined">
              <InputLabel
                htmlFor="confirmPassword"
                shrink
                sx={{ background: "#fff", px: 0.5 }}
              >
                Confirm Password
              </InputLabel>
              <OutlinedInput
                id="confirmPassword"
                name="confirmPassword"
                type={showPassword.confirmPassword ? "text" : "password"}
                onChange={handleChange}
                placeholder="Confirm Password"
                sx={{ background: "white" }}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => handleTogglePassword("confirmPassword")}
                      edge="end"
                      aria-label="toggle password visibility"
                    >
                      {showPassword.confirmPassword ? (
                        <VisibilityOff />
                      ) : (
                        <Visibility />
                      )}
                    </IconButton>
                  </InputAdornment>
                }
                label="Confirm Password"
              />
            </FormControl>
            <Box sx={{ mt: 1 }}>
              <Box
                sx={{
                  height: "4px",
                  width: "100%",
                  backgroundColor: "lightgray",
                  borderRadius: "2px",
                  overflow: "hidden",
                }}
              >
                <Box
                  sx={{
                    height: "100%",
                    width: `${strengthConf.strength}%`,
                    backgroundColor: strengthConf.color,
                  }}
                />
              </Box>
              <Typography
                variant="caption"
                color={strengthConf.color}
                sx={{ mt: 1, textAlign: "right", display: "block" }}
              >
                {strengthConf.label}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            gap: 2,
            justifyContent: "flex-end",
          }}
        >
          <Button
            variant="contained"
            disableElevation
            size="large"
            sx={{
              textTransform: "capitalize",
              minWidth: "140px",
            }}
            onClick={handleSubmit}
          >
            Save
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default PassResetForm;
